import React from 'react';

import { SketchPicker } from 'react-color';

export default function ColourInput({
  colour,
  isOpen,
  name,
  onChange,
  onClick,
}) {
  const handlePickerChange = (e) => {
    onChange({ colour: e.hex });
  };

  return (
    <div className='colour-field'>
      <input
        className='colour-field__input tw-border-grey-300 tw-font-inter tw-text-m tw-font-normal tw-tracking-auto placeholder:tw-text-grey-300 focus-within:tw-border-blue-300 hover:tw-border-grey-400 hover:focus-within:tw-border-blue-300'
        name={name}
        onClick={onClick}
        readOnly={true}
        value={colour}
      />
      <span className='colour-field__swatch' style={{ background: colour }} />
      {isOpen && (
        <div className='colour-field__picker-wrapper'>
          <div
            className='popup__backdrop popup__backdrop--low'
            onClick={onClick}
          />
          <SketchPicker color={colour} onChange={handlePickerChange} />
        </div>
      )}
    </div>
  );
}
